// extracted by mini-css-extract-plugin
export default {"proyects":"AllProyect_proyects__gnKNI","links":"AllProyect_links__guvSZ","icon":"AllProyect_icon__uhAxn","icon2":"AllProyect_icon2__14mn4"};